import React from 'react';
import { Menu } from 'antd';
import styled from 'styled-components'

import { useToggleMenu } from "../../../context/MenuProvider";

import MainMenu from './MainMenu';

const Collapse = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'dataCollapsed',
})`
  width: 280px;
  height: 100vh;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;

  position: absolute;
  z-index: 1;
  left: ${({ dataCollapsed }) => dataCollapsed ? '-280px' : '0'};

  transition: left 0.3s;

  & .ant-menu {
    width: 100%;
  }
`

const StyledMenu = styled(Menu)`
  &.ant-menu {
    background-color: #ffffff;
  }
  &.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: rgb(225, 230, 237);
  }
`;


export const Sidebar = () => {

  const { isMenuOpen } = useToggleMenu();

  return (
      <Collapse dataCollapsed={!isMenuOpen}>
        <StyledMenu
          mode="vertical"
          inlineCollapsed={!isMenuOpen}
        >
          <MainMenu data-collapsed={!isMenuOpen} />
        </StyledMenu>
      </Collapse>
  );
};